<template>
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <form novalidate @submit.prevent="submit"> 

          <Input 
            type="text" 
            @on-input="emailInput" 
            :isError="invalidEmail()"
            :textError="errorTextEmail"
            caption="Email:"
          />

          <Input 
            type="password" 
            @on-input="passInput" 
            caption="Пароль:"
          />

          <div class="form-group text-center">
            <router-link :to="{ name: 'ResetPassword' }" class="d-inline"> Забыли пароль? </router-link> | 
            <router-link :to="{ name: 'Registration' }" class="d-inline"> Регистрация </router-link>
          </div>

          <button class="btn btn-primary" type="button" disabled v-if="showWait">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Загрузка...
          </button>
          <button type="submit" class="btn btn-primary" v-else>
            Войти
          </button>

          <div class="form-group text-center">
              <br />
              <p>Уже зарегистрированы на сайте <a href="https://tracker.aopa.ru/">АОПА-Трекер</a> или <a href="https://maps.aopa.ru/">АОПА-Карты</a>? Авторизуйтесь на любом из этих сайтов и вернитесь на эту страницу. Вход в личный кабинет произойдёт автоматически.</p>
          </div>


        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Input from '@/components/Input.vue'
import { minLength, testEmail } from '@/utils/Validate.js'

export default {
  components: {
    Input
  },
  data() {
    return {
      email: '',
      pass: '',
      emailError: {
        minLength: false,
        wrongEmail: false,
        wrongPass: false
      },
      showWait: false
    }
  },
  computed: {
    errorTextEmail: function() {
      let error = "";
      if (this.emailError.minLength) error = "Поле email не должно быть пустым!"
      if (this.emailError.wrongPass) error = "Не верный логин или пароль!"
      if (this.emailError.wrongEmail) error = "Введите корректный email"
      return error;
    },
  },
  methods: {
    emailInput(value) {
      this.emailError.minLength = minLength(value)
      this.emailError.wrongPass = false
      this.emailError.wrongEmail = false
      this.email = value
    },
    passInput(value) {
      this.emailError.wrongPass = false
      this.pass = value
    },
    invalidEmail() {
      for (let key in this.emailError) {
        if (this.emailError[key]) return true
      }
      return false
    },
    submit() {
      this.emailError.minLength = minLength(this.email)
      this.emailError.wrongEmail = !testEmail(this.email)

      if (!this.invalidEmail()) {
        this.showWait = true;
        const formData = new FormData();
        formData.append('email', this.email)
        formData.append('pass', this.pass)

        //console.log('login')

        this.$store.dispatch('loginUserWithPass', formData)
        .then(() => { 
          this.showWait = false;
          //this.$router.push({ name: 'Account' })
        })
        .catch((e) => {
          this.showWait = false;
          if (e.response.status === 401) this.emailError.wrongPass = true
        })
      }
    }
  }
  
}
</script>
